var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElement86(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 407.9 241",
    style: {
      enableBackground: "new 0 0 407.9 241"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st1{enable-background:new    ;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "149.6,240.5 75.1,240.5 0.6,120.5 75.1,0.5 149.6,0.5  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.9,79.5c-0.6-0.8-1.3-1.5-2-2.1c-1.3-0.9-2.9-1.5-4.7-1.5c-4.2,0-8.1,3.2-8.1,8.3c0,5.3,4,8.5,8.1,8.5 c2,0,3.8-0.6,5.1-1.6c1.4-1,2.3-2.4,2.6-4h-9.6v-2.9h13.7c0,1.4-0.2,3.3-1,5c-2,4.4-6.6,6.6-10.8,6.6 c-6.6,0-11.7-5.1-11.7-11.6c0-6.6,5.2-11.5,11.7-11.5c4.8,0,9.1,2.9,10.6,6.7H94.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.1,73.2h3.1v22.2h-3.1V73.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.4,87.2c0-4.3,3.2-8.6,8.7-8.6s8.7,4.3,8.7,8.6c0,4.4-3.2,8.6-8.7,8.6S109.4,91.6,109.4,87.2 L109.4,87.2z M112.5,87.3c0,3.2,2.5,5.7,5.6,5.7c3.1,0,5.6-2.4,5.6-5.7c0-3.3-2.5-5.7-5.6-5.7C114.9,81.5,112.5,84,112.5,87.3 L112.5,87.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M129.9,73.2h3.1v5.9v2.6c1.5-2.1,3.9-3.1,6-3.1c4.2,0,8.3,3.1,8.3,8.6c0,5.2-3.7,8.7-8.4,8.7 c-2.8,0-4.9-1.4-6-3.3v2.8h-3V73.2z M144.2,87.2c0-3.2-2.4-5.7-5.6-5.7c-3.4,0-5.6,2.6-5.6,5.7c0,3.1,2.2,5.8,5.5,5.8 C142.2,93,144.2,90.1,144.2,87.2L144.2,87.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M167.1,95.4H164v-2.8c-1.1,2.2-3.5,3.3-6.1,3.3c-5.2,0-8.4-4.1-8.4-8.6c0-5,3.6-8.6,8.4-8.6 c3.2,0,5.3,1.8,6.1,3.4v-2.9h3.1V95.4z M152.7,87.3c0,2.4,1.7,5.7,5.7,5.7c2.5,0,4.3-1.4,5.1-3.2c0.4-0.8,0.5-1.6,0.6-2.4 c0-0.8-0.1-1.7-0.5-2.4c-0.8-1.9-2.6-3.4-5.2-3.4C154.9,81.5,152.7,84.2,152.7,87.3L152.7,87.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M171.2,73.2h3.1v22.2h-3.1V73.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M187.3,73.2h6.6c2.1,0,3.6,0.4,4.7,1.2c1.6,1,2.2,2.7,2.2,4.5c0,2.3-1.2,3.8-2.8,4.6c3.8,1.2,4,4.5,4,5.5 c0,2.2-1,4-2.7,5.1c-1.6,1.1-2.9,1.3-5.6,1.3h-6.5V73.2z M190.9,82.4h2.9c0.8,0,1.6-0.1,2.2-0.4c1.1-0.6,1.5-1.6,1.5-2.7 c0-1.4-0.7-2.2-1.5-2.6c-0.5-0.3-1.2-0.4-2.3-0.4h-2.8V82.4z M190.9,92.3h3.6c0.7,0,1.6-0.1,2.4-0.4c1.1-0.5,1.9-1.4,2-3.1 c0-1.5-0.8-2.6-2-3.1c-0.9-0.4-1.6-0.4-2.7-0.4h-3.3V92.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M205.2,79.1h2.9v2.4c0.9-1.9,2.6-2.8,4.9-2.9v3.1h-0.2c-2.9,0-4.5,1.6-4.5,4.9v8.8h-3.1V79.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M230.9,95.4h-3.1v-2.8c-1.1,2.2-3.5,3.3-6.1,3.3c-5.2,0-8.4-4.1-8.4-8.6c0-5,3.6-8.6,8.4-8.6 c3.2,0,5.3,1.8,6.1,3.4v-2.9h3.1V95.4z M216.5,87.3c0,2.4,1.7,5.7,5.7,5.7c2.5,0,4.3-1.4,5.1-3.2c0.4-0.8,0.5-1.6,0.6-2.4 c0-0.8-0.1-1.7-0.5-2.4c-0.8-1.9-2.6-3.4-5.2-3.4C218.7,81.5,216.5,84.2,216.5,87.3L216.5,87.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M235,79.1h2.9v2.5c0.8-1.7,2.6-3,5.5-3c5.2,0.1,6.6,3.8,6.6,7.2v9.6h-3.2v-8.8c0-2.9-1.1-5-4.3-5 c-3.1,0-4.5,2-4.5,4.8v9.1H235V79.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M270.6,95.4h-3v-2.8c-0.9,1.7-2.7,3.3-6.1,3.3c-5.1,0-8.4-4-8.4-8.7c0-5.1,3.7-8.6,8.3-8.6 c3.3,0,5.4,1.9,6,3.1v-2.9v-5.7h3.1V95.4z M256.3,87.2c0,3,2.1,5.7,5.7,5.7c1.6,0,3.1-0.7,4.1-1.7c1-1,1.7-2.5,1.6-4.1 c0-1.6-0.6-3-1.7-4c-1-1-2.4-1.6-4-1.6C258.6,81.5,256.3,84.1,256.3,87.2L256.3,87.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M282,83.3c0-1.3-0.8-2.2-2.4-2.2c-1.5,0-2.4,1-2.3,2.1c0.1,1.3,1.2,1.9,3,2.4c2.5,0.7,5.2,1.4,5.3,4.9 c0.1,3.2-2.6,5.3-5.8,5.3c-2.6,0-5.8-1.5-5.9-5.2h3.1c0.1,2,1.7,2.6,2.9,2.6c1.5,0,2.7-1,2.7-2.4c0-1.6-1.3-2.2-4.2-3.1 c-2.3-0.7-4.1-1.8-4.1-4.2c0-3.1,2.5-4.9,5.5-4.9c2.2,0,5.2,1.1,5.4,4.7H282z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M312.6,95.4h-2.9v-2.5c-0.8,1.7-2.6,3-5.5,3c-5.2,0-6.6-3.8-6.6-7.2v-9.6h3.1v8.8c0,2.9,1.1,5,4.3,5 c3.1,0,4.5-2,4.5-4.8v-9.1h3.1V95.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M316.7,79.1h2.9v2.5c0.8-1.7,2.6-3,5.5-3c5.2,0.1,6.6,3.8,6.6,7.2v9.6h-3.1v-8.8c0-2.9-1.1-5-4.3-5 c-3.1,0-4.5,2-4.5,4.8v9.1h-3.1V79.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M352.3,95.4h-3v-2.8c-0.9,1.7-2.7,3.3-6.1,3.3c-5.1,0-8.4-4-8.4-8.7c0-5.1,3.7-8.6,8.3-8.6 c3.3,0,5.4,1.9,6,3.1v-2.9v-5.7h3.1V95.4z M338,87.2c0,3,2.1,5.7,5.7,5.7c1.6,0,3.1-0.7,4.1-1.7c1-1,1.6-2.5,1.6-4.1 c0-1.6-0.6-3-1.6-4c-1-1-2.4-1.6-4-1.6C340.3,81.5,338,84.1,338,87.2L338,87.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.6,131.4v-22.2h3.5v9.4h9.6v-9.4h3.5v22.2h-3.5v-9.7h-9.6v9.7H77.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M98.4,109.2h3.1v3.3h-3.1V109.2z M98.4,115.1h3.1v16.3h-3.1V115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M122.1,131.4h-3v-2.8c-0.9,1.7-2.7,3.3-6.1,3.3c-5.1,0-8.4-4-8.4-8.7c0-5.1,3.7-8.6,8.3-8.6 c3.3,0,5.4,1.9,6,3.1v-2.9v-5.7h3.1V131.4z M107.8,123.2c0,3,2.1,5.7,5.7,5.7c1.6,0,3.1-0.7,4.1-1.7c1-1,1.6-2.5,1.6-4.1 c0-1.6-0.6-3-1.6-4c-1-1-2.4-1.6-4-1.6C110.1,117.5,107.8,120.1,107.8,123.2L107.8,123.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M142.8,131.4h-3v-2.8c-0.9,1.7-2.7,3.3-6.1,3.3c-5.1,0-8.4-4-8.4-8.7c0-5.1,3.7-8.6,8.3-8.6 c3.3,0,5.4,1.9,6,3.1v-2.9v-5.7h3.1V131.4z M128.5,123.2c0,3,2.1,5.7,5.7,5.7c1.6,0,3.1-0.7,4.1-1.7c1-1,1.6-2.5,1.6-4.1 c0-1.6-0.6-3-1.6-4c-1-1-2.4-1.6-4-1.6C130.8,117.5,128.5,120.1,128.5,123.2L128.5,123.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M149,124.2c0.1,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.6,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H149z M159.8,121.8 c-0.1-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H159.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M166,115.1h2.9v2.5c0.8-1.7,2.6-3,5.5-3c5.2,0.1,6.6,3.8,6.6,7.2v9.6h-3.1v-8.8c0-2.9-1.1-5-4.3-5 c-3.1,0-4.5,2-4.5,4.8v9.1H166V115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M196.4,124.8c0.2,3.3,2.6,4,3.8,4c2,0,3.7-1.6,3.7-3.5c0-2.5-2.1-3-5-4.1c-1.7-0.6-5.6-1.9-5.6-6 c0-4.1,3.5-6.4,7-6.4c2.9,0,6.4,1.6,6.7,6.1h-3.5c-0.2-1.2-0.8-3.1-3.3-3.1c-1.8,0-3.4,1.2-3.4,3.1c0,2.2,1.6,2.7,5.2,4 c2.8,1.2,5.3,2.6,5.3,6.2c0,3.6-2.4,6.7-7.2,6.7c-4.4,0-7.2-2.7-7.3-7H196.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M211.5,117.5h-2.9v-2.4h2.9v-5.9h3.1v5.9h3.1v2.4h-3.1v13.9h-3.1V117.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M235.9,131.4h-3.1v-2.8c-1.1,2.2-3.5,3.3-6.1,3.3c-5.2,0-8.4-4.1-8.4-8.6c0-5,3.6-8.6,8.4-8.6 c3.2,0,5.3,1.8,6.1,3.4v-2.9h3.1V131.4z M221.5,123.3c0,2.4,1.7,5.7,5.7,5.7c2.5,0,4.3-1.4,5.1-3.2c0.4-0.8,0.5-1.6,0.6-2.4 s-0.1-1.7-0.5-2.4c-0.8-1.9-2.6-3.4-5.2-3.4C223.7,117.5,221.5,120.2,221.5,123.3L221.5,123.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M240,115.1h2.9v2.4c0.9-1.9,2.6-2.8,4.9-2.9v3.1h-0.2c-2.9,0-4.5,1.6-4.5,4.9v8.8H240V115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M257.3,119.3c0-1.3-0.8-2.2-2.4-2.2c-1.5,0-2.4,1-2.3,2.1c0.1,1.3,1.2,1.9,3,2.4c2.5,0.7,5.2,1.4,5.3,4.9 c0.1,3.2-2.6,5.3-5.8,5.3c-2.6,0-5.8-1.5-5.9-5.2h3.1c0.1,2,1.7,2.6,2.9,2.6c1.5,0,2.7-1,2.7-2.4c0-1.6-1.3-2.2-4.2-3.1 c-2.3-0.7-4.1-1.8-4.1-4.2c0-3.1,2.5-4.9,5.5-4.9c2.2,0,5.2,1.1,5.4,4.7H257.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M273,109.2h3.1v3.3H273V109.2z M273,115.1h3.1v16.3H273V115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M280.2,115.1h2.9v2.3c0.7-1.4,2.6-2.8,5-2.8c1.5,0,3.1,0.4,4.2,1.7c0.4,0.4,0.9,1.3,1,1.6 c0.3-0.5,0.6-1,1.2-1.6c1.1-1,2.6-1.7,4.3-1.7c1.5,0,3.2,0.4,4.4,1.6c1.4,1.5,1.8,3,1.8,6.1v9h-3.1v-8.9c0-1.4-0.2-2.7-0.9-3.6 c-0.6-0.8-1.4-1.3-2.9-1.3c-1.4,0-2.5,0.6-3.1,1.6c-0.7,1-0.8,1.9-0.8,3.3v9H291v-9c0-1.4-0.1-2.3-0.7-3.2 c-0.6-1-1.6-1.6-3.1-1.6c-1.5,0-2.5,0.7-3.1,1.6c-0.6,0.9-0.9,2-0.9,3.3v8.9h-3.1V115.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.1,145.2h3.5v10.5l8.1-10.5h3.8l-8.6,11.1l9.5,11.1H90l-8.4-10.2v10.2h-3.5V145.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M110.1,167.4h-2.9v-2.5c-0.8,1.7-2.6,3-5.5,3c-5.2,0-6.6-3.8-6.6-7.2v-9.6h3.1v8.8c0,2.9,1.1,5,4.3,5 c3.1,0,4.5-2,4.5-4.8v-9.1h3.1V167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M114.2,151.1h2.9v2.5c0.8-1.7,2.6-3,5.5-3c5.2,0.1,6.6,3.8,6.6,7.2v9.6h-3.1v-8.8c0-2.9-1.1-5-4.3-5 c-3.1,0-4.5,2-4.5,4.8v9.1h-3.1V151.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M149.8,167.4h-3v-2.8c-0.9,1.7-2.7,3.3-6.1,3.3c-5.1,0-8.4-4-8.4-8.7c0-5.1,3.7-8.6,8.3-8.6 c3.3,0,5.4,1.9,6,3.1v-2.9v-5.7h3.1V167.4z M135.4,159.2c0,3,2.1,5.7,5.7,5.7c1.6,0,3.1-0.7,4.1-1.7c1-1,1.6-2.5,1.6-4.1 c0-1.6-0.6-3-1.6-4c-1-1-2.4-1.6-4-1.6C137.7,153.5,135.4,156.2,135.4,159.2L135.4,159.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M155.9,160.2c0.1,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.6,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H155.9z M166.8,157.8 c-0.1-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H166.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M172.9,151.1h2.9v2.5c0.8-1.7,2.6-3,5.5-3c5.2,0.1,6.6,3.8,6.6,7.2v9.6h-3.1v-8.8c0-2.9-1.1-5-4.3-5 c-3.1,0-4.5,2-4.5,4.8v9.1h-3.1V151.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M192,151.1h3v2.8c1.2-1.9,3.3-3.3,6.2-3.3c5.6,0,8.2,4.7,8.2,8.7c0,4.6-3.3,8.5-8.2,8.5 c-3.4,0-5.4-1.9-6.1-3.2v2.7v5.9H192V151.1z M206.3,159.2c0-2.7-1.9-5.7-5.7-5.7c-1.6,0-3,0.6-4,1.7c-1,1-1.6,2.5-1.6,4.1 s0.6,3,1.6,4c1,1,2.5,1.7,4,1.7C204,165,206.3,162.4,206.3,159.2L206.3,159.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M211.7,159.2c0-4.3,3.2-8.6,8.7-8.6s8.7,4.3,8.7,8.6c0,4.4-3.2,8.6-8.7,8.6S211.7,163.6,211.7,159.2 L211.7,159.2z M214.8,159.3c0,3.2,2.5,5.7,5.6,5.7c3.1,0,5.6-2.4,5.6-5.7c0-3.3-2.5-5.7-5.6-5.7 C217.3,153.5,214.8,156,214.8,159.3L214.8,159.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M232.3,151.1h2.9v2.4c0.9-1.9,2.6-2.8,4.9-2.9v3.1h-0.2c-2.9,0-4.5,1.6-4.5,4.9v8.8h-3.1V151.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M244.3,153.5h-2.9v-2.4h2.9v-5.9h3.1v5.9h3.2v2.4h-3.2v13.9h-3.1V153.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M253.2,153.5H251v-2.4h2.2V150c0-4.9,3.8-5.2,6.1-5.2v2.5c-1.1,0-3,0-3,2.9v1h3v2.4h-3v13.9h-3.1V153.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M260,159.2c0-4.3,3.2-8.6,8.7-8.6c5.5,0,8.7,4.3,8.7,8.6c0,4.4-3.2,8.6-8.7,8.6 C263.2,167.9,260,163.6,260,159.2L260,159.2z M263.1,159.3c0,3.2,2.5,5.7,5.6,5.7s5.6-2.4,5.6-5.7c0-3.3-2.5-5.7-5.6-5.7 S263.1,156,263.1,159.3L263.1,159.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M280.5,145.2h3.1v22.2h-3.1V145.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M287.8,145.2h3.1v3.3h-3.1V145.2z M287.8,151.1h3.1v16.3h-3.1V151.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M294,159.2c0-4.3,3.2-8.6,8.7-8.6c5.5,0,8.7,4.3,8.7,8.6c0,4.4-3.2,8.6-8.7,8.6 C297.2,167.9,294,163.6,294,159.2L294,159.2z M297.1,159.3c0,3.2,2.5,5.7,5.6,5.7s5.6-2.4,5.6-5.7c0-3.3-2.5-5.7-5.6-5.7 S297.1,156,297.1,159.3L297.1,159.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M318,167.4h-3.3v-3.9h3.3V167.4z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElement86);
export default __webpack_public_path__ + "static/media/Element 86.24b9dfecd19b6aafe5f7fcc1c4ac5cd4.svg";
export { ForwardRef as ReactComponent };